import { Flex } from "@chakra-ui/react"
import useSidebarV2 from "../useSidebarV2"
import GroupMenu from "./GroupMenu"
import sidebarV2Store from "../../../stores/sidebar-v2.store"
import teamStore from "../../../stores/team.store"

export default function GroupMenus() {
  const { searchMenus, grantedMenus } = useSidebarV2()
  const { search } = sidebarV2Store()
  const { team } = teamStore()

  return (
    <Flex 
      direction='column' 
      marginTop='12px' 
      gap='24px'
      overflow='auto'
      sx={{
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "rgba(255, 255, 255, 0.3)", // light mode adjust
          borderRadius: "12px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: "rgba(255, 255, 255, 0.5)",
        },
      }}
      paddingBottom="50px"
    >
      {searchMenus(grantedMenus(team?.id as number), search??'')?.map((groupMenu, groupMenuIndex) => {
        return (
          <GroupMenu key={groupMenuIndex} groupMenu={groupMenu} />
        )
      })}
    </Flex>
  )
}
